import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { FC } from "react";

interface YearPickerProps {
  selectedYear: number;
  onYearChange: (year: number) => void;
  earliestSelectableDate?: Date;
}

export const YearPicker: FC<YearPickerProps> = ({
  selectedYear,
  onYearChange,
  earliestSelectableDate = new Date(Date.UTC(0, 0, 1)),
}) => {
  const theme = useTheme();

  const earliestYear = earliestSelectableDate.getUTCFullYear();
  const isPrevYearDisabled = selectedYear - 1 < earliestYear;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 6,
        pt: 2,
        pb: 1,
      }}
    >
      <IconButton
        disabled={isPrevYearDisabled}
        onClick={() => onYearChange(selectedYear - 1)}
        size="small"
        sx={{
          color: theme.colors.primary[5],
        }}
      >
        <ChevronLeft />
      </IconButton>
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          color: theme.colors.text[5],
          userSelect: "none",
        }}
      >
        {selectedYear}
      </Typography>
      <IconButton
        onClick={() => onYearChange(selectedYear + 1)}
        size="small"
        sx={{
          color: theme.colors.primary[5],
        }}
      >
        <ChevronRight />
      </IconButton>
    </Box>
  );
};
